import React, { useState, useEffect} from 'react'
import {  useNavigate } from 'react-router-dom';
import "./Navbar.css"
function Navbar() {

  const [show, handleShow] = useState(false);
  const navigate = useNavigate();
  const TransitionNavBar = () => {
    if (window.scrollY > 100 ) {
      handleShow (true);
    }
    else {
      handleShow(false);
    }
    useEffect(() => {
      window.addEventListener("scroll", TransitionNavBar);

    
      return () => {
        window.removeEventListener("scroll" , TransitionNavBar);
      }
    }, []);
    
  }
  return (
   
    <div className={`navbar ${show &&"navbar__black"}`}>
      <div className="navbar__contents">
      <img  onClick={() => navigate("/")}
       className='navbar__logo' 
        src="http://assets.stickpng.com/images/580b57fcd9996e24bc43c529.png" 
        alt="" />
         <img onClick={() => navigate("/profile")}
         className='navbar__avatar'
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-W6yn_THZi4dt3WCZKmAiTQCKAl1pZ2RvIw&usqp=CAU"
           alt="" />
      </div>
 
    </div>
  )
}

export default Navbar;